import { AssembleEdit } from './AssembleEdit';

export default AssembleEdit;
